export default __webpack_public_path__ + "static/media/trendy.3a10159f.svg";